"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var useWrapEvent_1 = __importDefault(require("@seaweb/coral/hooks/useWrapEvent"));
var useForkRef_1 = __importDefault(require("@seaweb/coral/hooks/useForkRef"));
require("focus-visible");
var Div = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: transparent;\n\n  ", "\n\n  cursor: pointer;\n\n  ", "\n\n  &:focus {\n    outline: none;\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: transparent;\n\n  ",
    "\n\n  cursor: pointer;\n\n  ",
    "\n\n  &:focus {\n    outline: none;\n  }\n"])), function (_a) {
    var _b = _a.theme, colors = _b.colors, typography = _b.typography;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    font-family: ", ";\n    font-size: ", "px;\n  "], ["\n    color: ", ";\n    font-family: ", ";\n    font-size: ", "px;\n  "])), colors.alternate, typography.main, typography.sizes.main);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      cursor: not-allowed;\n    "], ["\n      cursor: not-allowed;\n    "])));
});
var DEFAULT_CLICK_KEYS = ['Enter', ' '];
var BaseButton = react_1.forwardRef(function (_a, ref) {
    var _b = _a.tabIndex, tabIndexProp = _b === void 0 ? 0 : _b, _c = _a.role, role = _c === void 0 ? 'button' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseLeave = _a.onMouseLeave, onTouchStart = _a.onTouchStart, onTouchEnd = _a.onTouchEnd, onBlur = _a.onBlur, onClick = _a.onClick, onRelease = _a.onRelease, _e = _a.keyboardClickKeys, keyboardClickKeys = _e === void 0 ? DEFAULT_CLICK_KEYS : _e, props = __rest(_a, ["tabIndex", "role", "disabled", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseUp", "onMouseLeave", "onTouchStart", "onTouchEnd", "onBlur", "onClick", "onRelease", "keyboardClickKeys"]);
    var tabIndex = disabled ? null : tabIndexProp;
    var ownRef = react_1.useRef(null);
    var handleRef = useForkRef_1.default(ref, ownRef);
    var handleClick = function (e) {
        if (!disabled && onClick) {
            onClick(e);
        }
    };
    var handleRelease = function (e) {
        if (onRelease)
            onRelease(e);
    };
    var _f = __read(react_1.useState({}), 2), pressed = _f[0], setPressed = _f[1];
    var handleSetPressed = function (name, p) {
        if (!disabled) {
            setPressed(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[name] = p, _a)));
            });
        }
    };
    var handleMouseDown = useWrapEvent_1.default(onMouseDown, function () { return handleSetPressed('mouse', true); });
    var handleMouseUp = useWrapEvent_1.default(onMouseUp, function (e) {
        handleSetPressed('mouse', false);
        handleRelease(e);
    });
    var handleMouseLeave = useWrapEvent_1.default(onMouseLeave, function () { return handleSetPressed('mouse', false); });
    var handleTouchStart = useWrapEvent_1.default(onTouchStart, function () { return handleSetPressed('touch', true); });
    var handleTouchEnd = useWrapEvent_1.default(onTouchEnd, function (e) {
        handleSetPressed('touch', false);
        handleRelease(e);
    });
    var handleBlur = useWrapEvent_1.default(onBlur, function () {
        keyboardClickKeys.forEach(function (key) { return handleSetPressed("keyboard-" + key, false); });
    });
    var handleKeyDown = useWrapEvent_1.default(onKeyDown, function (e) {
        if (keyboardClickKeys.includes(e.key)) {
            if (!pressed["keyboard-" + e.key]) {
                handleSetPressed("keyboard-" + e.key, true);
                handleClick(e);
            }
        }
    });
    var handleKeyUp = useWrapEvent_1.default(onKeyUp, function (e) {
        if (keyboardClickKeys.includes(e.key)) {
            handleSetPressed("keyboard-" + e.key, false);
            handleRelease(e);
        }
    });
    react_1.useEffect(function () {
        if (disabled)
            setPressed({});
    }, [disabled]);
    var dataCoral = {};
    if (Object.values(pressed).some(Boolean)) {
        dataCoral['data-coral-pressed'] = '';
    }
    if (disabled) {
        dataCoral['data-coral-disabled'] = '';
    }
    return (react_1.default.createElement(Div, __assign({ role: role, ref: handleRef, tabIndex: tabIndex, onClick: handleClick, onBlur: handleBlur, onKeyDown: handleKeyDown, onKeyUp: handleKeyUp, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, onMouseLeave: handleMouseLeave, onTouchStart: handleTouchStart, onTouchEnd: handleTouchEnd, "aria-disabled": disabled || null, disabled: disabled }, dataCoral, props)));
});
exports.default = react_1.memo(BaseButton);
var templateObject_1, templateObject_2, templateObject_3;
